<template>
  <div class="pairs-list">
    <el-row v-for="(item, index) in list" :key="index" class="list-item" :gutter="20">
      <el-col :span="6">
        <el-input v-model="item.key"></el-input>
      </el-col>
      <el-col :span="17" class="flexRow item-value">
        <!-- 不使用流程中变量 -->
        <el-input
          v-if="!useFlowVar"
          v-model="item.value.value"
          @change="item.value.label = item.value.value"
        ></el-input>
        <!-- 可使用流程中变量 -->
        <template v-else>
          <el-input
            v-if="!item.value.inFlow"
            v-model="item.value.value"
            @change="item.value.label = item.value.value"
            class="reset-border"
          ></el-input>
          <div v-else class="var-container">
            <span class="var">{{ item.value.label }}</span>
            <div class="icon-close" @click="deleteFlowVar(index)">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <el-tooltip effect="dark" content="使用本流程节点对象的值" placement="top">
            <group-dropdown-menu :group-list="can2strVars" @select="selectFlowVar(index, $event)">
              <div class="btn-add buttonSelectTrigger">
                <i class="el-icon-plus"></i>
              </div>
            </group-dropdown-menu>
          </el-tooltip>
        </template>
        <i class="el-icon-delete-solid icon-del" @click="delPair(index)"></i>
      </el-col>
    </el-row>
    <div class="mTop10">
      <span class="add-item" @click="addPair">{{ addItemText }}</span>
    </div>
  </div>
</template>

<script>
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"
import mixin from "./mixin"

export default {
  components: {
    GroupDropdownMenu
  },
  props: {
    list: Array,
    can2strVars: Array,
    addItemText: {
      type: String,
      default: "+"
    },
    title: {
      type: String,
      default: "key - value"
    },
    useFlowVar: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixin],
  methods: {
    addPair() {
      if (!this.verifyPairs(this.list, "add")) return
      this.list.push({
        key: "",
        value: {
          label: "",
          value: "",
          inFlow: false
        }
      })
    },
    delPair(index) {
      this.list.splice(index, 1)
    },
    selectFlowVar(index, item) {
      this.$set(this.list[index], "value", {
        label: item.label,
        value: item.value,
        inFlow: true
      })
    },
    deleteFlowVar(index) {
      this.list[index].value = {
        label: "",
        value: "",
        inFlow: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pairs-list {
  .list-item {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .add-item {
    cursor: pointer;
    color: #9e9e9e;
    &:hover {
      color: #1e88e5;
    }
  }
  .btn-add {
    min-width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-width: 1px 1px 1px 0;
    border-style: solid;
    box-sizing: border-box;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-color: #ddd;
    font-size: 20px;
    color: #9e9e9e;
    cursor: pointer;
    &:hover {
      color: #1e88e5;
    }
  }
  .item-value {
    position: relative;
    &:hover {
      .icon-del {
        display: block;
      }
    }
    .var-container {
      width: 100%;
      position: relative;
      padding: 0 10px;
      background: #f8f8f8;
      border: 1px solid #ccc;
      min-height: 40px;
      line-height: 40px;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      box-sizing: border-box;
      &:hover {
        border-color: #2196f3;
      }
      .var {
        display: inline-flex;
        margin-bottom: 2px;
        line-height: 28px;
        padding: 1px 10px;
        background-color: #01ca83;
        color: #fff;
        border-radius: 14px;
        border: 1px solid #9cd7f1;
      }
      .icon-close {
        position: absolute;
        top: 0;
        right: 10px;
        width: 20px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .icon-del {
      position: absolute;
      right: -8px;
      top: 12px;
      display: none;
      cursor: pointer;
      color: #bdbdbd;
      &:hover {
        color: #1e88e5;
      }
    }
  }
}
</style>

<style lang="scss">
.setHttpRequest .pairs-list {
  .reset-border {
    .el-input__inner {
      border: 1px solid #ccc;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &:hover {
        border-color: #2196f3;
      }
    }
  }
}
</style>
